import { useQuery } from "react-query"
import { ECalcOrigin } from "@tm/models"
import { FastService } from "@tm/data"
import { GenericHistoryEntry } from "../../data/models"

function getFastCalculatorHistory(vehicleId: string | undefined, tecDocTypeId: number | undefined) {
    if (vehicleId && tecDocTypeId) {
        return FastService.getSavedCalculations({
            kTypNr: tecDocTypeId!,
            vehicleId: vehicleId!,
            origin: ECalcOrigin.FastService,
            doNotShowOwnCalculations: true,
        })
    }

    return []
}

function getFastServiceHistorySummary(vin: string | undefined, vehicleId: string | undefined) {
    if (vin && vehicleId) {
        return FastService.getHistorySummary(vin, vehicleId)
    }

    return []
}

function getHistory(vin: string | undefined, vehicleId: string | undefined, tecDocTypeId: number | undefined) {
    return Promise.all([getFastServiceHistorySummary(vin, vehicleId), getFastCalculatorHistory(vehicleId, tecDocTypeId)])
}

export function useFastServiceHistorySummary(vin: string | undefined, vehicleId: string | undefined, tecDocTypeId: number | undefined) {
    const query = useQuery(["fastServiceHistorySummary", { vin, vehicleId, tecDocTypeId }], () => getHistory(vin, vehicleId, tecDocTypeId))

    let historyList: Array<GenericHistoryEntry> = []
    if (query.data) {
        const [fastService, fastCalculator] = query.data
        historyList = [...fastService, ...fastCalculator]

        historyList.sort((a, b) => {
            if (!a?.dateTime) {
                return 1
            }

            if (!b?.dateTime) {
                return -1
            }

            return new Date(b.dateTime).getTime() - new Date(a.dateTime).getTime()
        })
    }

    return {
        historyList,
        isLoading: query.isLoading,
    }
}
